import { render, staticRenderFns } from "./OfferEdit.vue?vue&type=template&id=5e889042&scoped=true&"
import script from "./OfferEdit.vue?vue&type=script&lang=js&"
export * from "./OfferEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e889042",
  null
  
)

export default component.exports